import { Component, OnInit } from '@angular/core'
import { WelcomePackageService } from '../../welcome-package.service'
import { LaunchDialogService } from '@spartacus/storefront'
import { Router } from '@angular/router'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-cart-model',
  templateUrl: './cart-model.component.html',
  styleUrls: ['./cart-model.component.scss'],
})
export class CartModelComponent implements OnInit {
  public unavailabeItem
  public errorMsg
  public addedToCart

  constructor(
    private welcomePackageService: WelcomePackageService,
    private launchDialogService: LaunchDialogService,
    private router: Router
  ) {
    this.errorMsg = false
    this.welcomePackageService.quoteUnavailabeEmitted$.subscribe((res) => {
      this.addedToCart = res.cartModifications
      this.unavailabeItem = res.nonCatalogProductList
      if (this.unavailabeItem.length > 0) {
        this.errorMsg = true
      }
    })
  }

  ngOnInit(): void {
    this.welcomePackageService.getUnavailableQuot()
  }
  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.CART_MODAL,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }

  navigateToCart(reason?: any): void {
    this.router.navigate(['/cart'])
    this.dismissModal(reason)
  }
}
